export const InviteContactModal: string = 'InviteContactModal';
